<template>
  <div class="register max-width">
    <div class="r_title font-30 fontweight-bo">注册新用户</div>

    <div class="r_model" v-if="!bShowNext">
      <template v-for="(item, index) in r_list">
        <div :key="item.id" class="r_mod_line font-14">
          <div class="r_mod_li_name color-prompt-deep">{{ item.name }}：</div>
          <input
            :maxlength="item.maxlength"
            class="r_mod_li_value"
            :type="item.pass ? 'password' : ''"
            v-model="item.value"
          />
          <!-- 提示 -->
          <div
            v-if="index !== 'shoujiyanzheng'"
            class="r_mod_li_prompt font-12 color-prompt"
          >
            {{ item.prompt }}
          </div>
          <!-- 手机验证 -->
          <div v-else class="r_mod_li_validation no-copy">
            <!-- 未发送验证码 -->
            <div
              v-if="!isSendCode"
              :class="{
                'r_mod_li_vali_btn font-12': true,
                r_mod_li_vali_btn_isClick: isSendClick,
              }"
              @click="func_sendCode"
            >
              发送手机验证码
            </div>
            <!-- 已发送验证码(计时) -->
            <div v-else class="r_mod_li_vali_timing">
              已发送（{{ isSendTime }}s）
            </div>
          </div>
        </div>
      </template>

      <div class="r_mod_btn no-copy">
        <div
          class="r_mod_btn_submit bgcolor-gradient-right font-16 fontweight-bo"
          @click="func_nextStep"
        >
          下一步
        </div>
        <div
          v-if="false"
          class="r_mod_btn_cancel color-prompt-deep font-14 fontweight-bo"
          @click="func_callHome"
        >
          返回首页
        </div>
      </div>
    </div>

    <div class="r_model" v-if="bShowNext">
      <template v-for="(item, index) in d_list">
        <div :key="item.id" class="r_mod_line font-14">
          <div class="r_mod_li_name color-prompt-deep" v-if="item.canModifyy">
            {{ item.name }}：
          </div>
          <v-distpicker
            v-if="item.value.constructor['name'] === 'Array'"
            wrapper="ade-model-plate-line-picker"
            :province="d_list[3]['value'][0]"
            :city="d_list[3]['value'][1]"
            :area="d_list[3]['value'][2]"
            @selected="func_distpicker"
          ></v-distpicker>
          <div :class="[!item.canModifyy ? 'shouhuodizhixiala' : '']">
            <o-vData
              v-if="item['data']"
              :key="item.id"
              :lineData="item"
              :func_input="inputChange"
              :func_click="func_SPEC_S"
            />
          </div>
          <input
            v-if="item.canModify"
            :maxlength="item.maxlength"
            class="r_mod_li_value"
            :type="item.pass ? 'password' : ''"
            v-model="item.value"
          />
          <div
            v-if="index !== 'shoujiyanzheng'"
            class="r_mod_li_prompt font-12 color-prompt"
          >
            {{ item.prompt }}
          </div>
        </div>
      </template>
      <div class="r_mod_line font-14">
        <div class="r_mod_li_name color-prompt-deep" style="margin-left: 120px">
          <input type="checkbox" v-model="isAgreed" />
          <router-link tag="a" target="_blank" to="/agreement"
            >同意用户协议</router-link
          >
        </div>
      </div>
      <div class="r_mod_btn no-copy">
        <div
          class="r_mod_btn_submit bgcolor-gradient-right font-16 fontweight-bo"
          @click="func_submit"
        >
          提交注册
        </div>

        <!-- gongsimingcheng: {
          name: "公司简称",
          value: "",
          prompt: "请填写公司简称(最长5位)",
          maxlength: 5
        },
        lianxiren: {
          name: "联系人",
          value: "",
          prompt: "该联系人为默认收货人",
          maxlength: 10
        },-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  req_register,
  req_sendsms,
  req_validatecode,
  req_userLogin,
  req_userInfo,
} from "@/services/user";
export default {
  name: "register",
  props: {},
  components: {},
  data() {
    return {
      isAgreed: false, //同意用户协议
      bShowNext: false, //显示下一步窗口
      xianshi: false,
      r_list: {
        shoujihaoma: {
          name: "手机号码",
          value: "",
          prompt: "可用于登录，请填写正确的手机号码",
          maxlength: 12,
        },
        shoujiyanzheng: {
          name: "短信验证",
          value: "",
          maxlength: 6,
        },
        shezhimima: {
          name: "设置密码",
          value: "",
          prompt: "",
          pass: true,
          maxlength: 12,
        },
        querenmima: {
          name: "确认密码",
          value: "",
          prompt: "",
          pass: true,
          maxlength: 12,
        },
        yaoqingma: {
          name: "邀请码",
          value: "",
          prompt: "请输入五位数邀请码",
          maxlength: 5,
        },
      },
      d_list: [
        {
          name: "公司简称",
          value: "",
          prompt: "请填写公司简称(最长五位)",
          maxlength: 5,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "公司全称",
          value: "",
          prompt: "请填写公司全称,选填",
          maxlength: 20,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "联系人",
          value: "",
          prompt: "联系人为公司负责人",
          maxlength: 6,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "区域",
          value: ["广东省", "广州市", "白云区"],
          prompt: "",
          canModify: false,
          canModifyy: true,
        },
        {
          name: "详细地址",
          value: "",
          prompt: "详细地址一旦填写不可更改！请认真填写",
          maxlength: 20,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "送货方式",
          value: "30",
          prompt: "",
          maxlength: 12,
          canModify: false,
          canModifyy: false,
          type: "select",
          data: [
            {
              type: "select",
              name: "工厂自取",
              value: "工厂自取",
              choose: true,
              select_show: false,
              select_data: [
                { name: "工厂自取", value: "30" },
                { name: "罗冲围取", value: "31" },
                { name: "松柏自取", value: "33" },
                { name: "鹤泰路自取", value: "32" },
                { name: "快递物流", value: "44" },
              ],
            },
          ],
        },
        {
          name: "QQ",
          value: "",
          prompt: "便于QQ联系,必填",
          maxlength: 20,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "收货人手机号码",
          value: "",
          prompt: "",
          maxlength: 12,
          canModify: true,
          canModifyy: true,
        },
        {
          name: "设计师手机号码",
          value: "",
          prompt: "",
          maxlength: 12,
          canModify: true,
          canModifyy: true,
        },
      ],
      isSendClick: false, //是否已点击发送验证码
      isSendCode: false, //是否已发送验证码
      isSendTime: 60, //验证码计时
      timerId: false,
      realSMS: -1, //接收到的短信验证码
      bindingid: -1,
      code: "",
      province: "广东省",
      city: "广州市",
      area: "白云区",
      binding2:'30',
    };
  },
  methods: {
    //输入框完成事件
    func_SPEC_S(event) {
      this.Delivery = event.target.innerText;
      this.d_list[5].data[0].name = event.target.innerText;
      for (let i in this.d_list[5]["data"][0].select_data) {
        if (this.d_list[5]["data"][0].select_data[i].name == event.target.innerText) {
            this.binding2 = this.d_list[5]["data"][0].select_data[i].value
        }
      }
    },
    inputChange(event) {
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pid, params);
    },
    //下一步
    async func_nextStep() {
      this.code = this.r_list["yaoqingma"]["value"];
      const url =
        "http://api.yin2015.com/api/Users/ValidateCode?code=" + this.code;
      // 判空
      for (let i in this.r_list) {
        if (this.r_list[i]["value"].length < 1) {
          this.$parent.msgChange(
            "warning",
            '请完善"' + this.r_list[i]["name"] + '"',
            ""
          );
          return;
        }
      }
      // 校验验证码
      if (
        parseInt(this.r_list["shoujiyanzheng"]["value"]) !==
        parseInt(this.realSMS)
      ) {
        this.$parent.msgChange("fail", "手机验证码不正确", "");
        return;
      }
      // 校验密码
      else if (
        this.r_list["shezhimima"]["value"] !==
        this.r_list["querenmima"]["value"]
      ) {
        this.$parent.msgChange("fail", "两次输入密码不一致", "");
        return;
      }
      // 校验邀请码
      const result = await req_validatecode(this.r_list["yaoqingma"]["value"]);
      if (result.success == false) {
        this.$parent.msgChange("fail", "邀请码输入错误", "");
        return;
      } else {
        this.bindingid = result.data.id;
        this.bShowNext = true;
      }
    },
    // 地区选择触发器
    func_distpicker(event) {
      this.d_list[3]["value"] = [
        event["province"]["code"] ? event["province"]["value"] : "",
        event["city"]["code"] ? event["city"]["value"] : "",
        event["area"]["code"] ? event["area"]["value"] : "",
      ];
      this.province = event.province.value;
      this.city = event.city.value;
      this.area = event.area.value;
    },
    // 提交注册
    async func_submit() {
      if (!this.isAgreed) {
        this.$parent.msgChange("fail", "你必须同意用户协议才能注册用户", "");
        return;
      }

      // 判空
      for (let i in this.d_list) {
        if (
          this.d_list[i]["value"].length < 1 &&
          this.d_list[i]["name"] !== "公司全称" &&
          this.d_list[i]["name"] !== "邮箱"
        ) {
          this.$parent.msgChange(
            "warning",
            '请完善"' + this.d_list[i]["name"] + '"',
            ""
          );
          return;
        }
      }
      if (
        this.province == "省" ||
        this.city == "市" ||
        this.area == "区" ||
        this.province == "" ||
        this.city == "" ||
        this.area == ""
      ) {
        this.$parent.msgChange("fail", "请完善收货区域", "");
        return;
      }

      if (this.d_list[7].value != "" && !this.is_Phone(this.d_list[7].value)) {
        this.$parent.msgChange("fail", "请输入正确的收货人手机号码", "");
        return;
      }
      if (this.d_list[8].value != "" && !this.is_Phone(this.d_list[8].value)) {
        this.$parent.msgChange("fail", "请输入正确的设计师手机号码", "");
        return;
      }

      const params = {
        //密码
        UserWord: this.r_list["shezhimima"]["value"],
        //联系人手机号码，默认为收货人
        Mobile: this.r_list["shoujihaoma"]["value"],
        //联系人
        Attn: this.d_list[2].value,
        //详细地址
        Address: this.d_list[4].value,
        //区域
        province: this.province,
        city: this.city,
        area: this.area,
        //公司全称
        fullName: this.d_list[1].value,
        // 公司简称
        Company: this.d_list[0].value,
        // 送货方式
        sendmode: this.binding2,
        //QQ
        QQ: this.d_list[6].value,
        //收货人手机号码
        Tel: this.d_list[7].value,
        //设计师手机号码
        DesignerTel: this.d_list[8].value,
        //用户ID
        Binding2: this.bindingid,
        Email: this.d_list[8].value,
        personInchargeTel: this.d_list[7].value,
      };
      this.$parent.loadingChange(true, "注册中....");
      const result = await req_register(params); //注册
      this.$parent.loadingChange(false);
      if (result.success) {
        //注册成功
        const resultGetUser = await req_userInfo(result.data["userid"]); //获取客户信息
        this.STORAGE.remove("g_userInfo"); //把缓存中用户信息删除
        this.STORAGE.remove("g_trollerList"); //把购物车删除

        // 2) 调用全局登录流程
        this.$parent.func_appLogin(resultGetUser.data);

        this.$parent.confirmChange(
          "success",
          "注册成功！您的会员号【" + result.data["userid"] + "】,可用于登录",
          () => {
            this.$router.push({
              name: "order",
            });
          },
          () => {},
          { yes: "前往报价", no: "" }
        );
      } else {
        this.$parent.msgChange("fail", "注册失败", result.msg);
      }
    },
    // itemchanged(item) {
    // 	if (item === 'gongsimingcheng') {
    // 		if (window.event.srcElement.value.length > 5) {
    // 			this.$parent.msgChange('fail', '公司名称不能大于5位', '');
    // 		}
    // 	}

    // },
    func_callHome() {
      this.$router.push("agreement");
    },
    // 生成从minNum到maxNum的随机数
    func_createRandom() {
      let random = "";
      for (let i = 0; i < 4; i += 1) {
        random += Math.floor(Math.random() * 10);
      }
      return random;
    },
    // 发送验证码
    async func_sendCode() {
      if (
        this.r_list["shoujihaoma"]["value"] &&
        this.r_list["shoujihaoma"]["value"].length === 11
      ) {
        this.isSendClick = true;
        //请求发送验证码
        //生成验证码
        this.realSMS = this.func_createRandom();
        const result = await req_sendsms(
          this.r_list["shoujihaoma"]["value"],
          this.realSMS
        );
        this.isSendClick = false;
        if (result.data["success"]) {
          //发送成功
          this.isSendCode = true;
          // 开始计时
          this.func_sendTime();
        } else if (result.data["success"] == false) {
          this.$parent.msgChange("warning", result.data.msg, "");
          //发送失败
          this.isSendCode = false;
        }
      } else {
        this.$parent.msgChange("warning", "请完善手机号码", "");
      }
    },
    func_sendTime() {
      this.timerId = setInterval(() => {
        if (this.isSendTime > 0) {
          this.isSendTime -= 1;
        } else {
          clearTimeout(this.timerId);
          this.isSendTime = 60;
          this.isSendCode = false;
        }
      }, 1000);
    },
    is_Email(str) {
      //判断是否邮箱格式
      var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
      return reg.test(str);
    },
    is_Phone(str) {
      //判断是否手机号码
      var reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
      return reg.test(str);
    },
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.timerId);
  },
};
</script>
<style src='@/style/register.css' scoped></style>


// WEBPACK FOOTER //
// src/pages/Register.vue